import Image from 'next/image';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SimpleGrid } from '@chakra-ui/react';
import serializer from '@/src/libs/serializer';

import OpenGraph from '@/components/OpenGraph';
import FullPage from '@/src/components/UI/FullPage';
import FunwooAPI, { MediaEntity, PublishedPostEntity } from '@/swagger';

type Props = {
  // media: Array<ReplaceValueType<MediaEntity, Date, number>>
  media: Array<ReplaceValueType<MediaEntity, Date, number>>;
  posts: Array<PublishedPostEntity>;
};
export default function MediaExposure({ media, posts }: Props) {
  return (
    <FullPage hasPadding hasHeaderPlaceHolder>
      <OpenGraph
        title='FUNWOO 德載國際不動產 - 媒體採訪'
        type='video'
        imageUrl='https://funwoo.com.tw/media/cw-nancy.webp'
        url='https://funwoo.com.tw/media'
      />
      {/*<div className={classNames('flex space-y-4 sm:space-y-0 sm:space-x-4', 'flex-col sm:flex-row')}>*/}
      {/*  <div className={'flex-1'}>*/}
      {/*    <PromotionVideo*/}
      {/*      videoId={'fQWQd-rBcsA'}*/}
      {/*      opts={{*/}
      {/*        playerVars: { start: 101 },*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className={'flex-1'}>*/}
      {/*    <PromotionVideo*/}
      {/*      videoId={'Ll87-kf8B7s'}*/}
      {/*      opts={{*/}
      {/*        playerVars: { start: 29 },*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className={'flex-1'}>*/}
      {/*    <PromotionVideo videoId={'85MMRooqruk'} />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<PromotionVideo videoId={process.env.NEXT_PUBLIC_MEDIA_YOUTUBE_ID} />*/}
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4} mt={8}>
        {posts.map((post, index: number) => (
          <Link key={post.id} href={post.foreignUrl || `/media/${post.uuid}`}>
            <a
              className='flex flex-col mb-4 space-y-4'
              target={post.foreignUrl ? '_blank' : '_self'}
              rel={post.foreignUrl ? 'noreferrer noopener' : ''}
            >
              <div>
                <Image
                  src={post.coverImage}
                  width={400}
                  height={300}
                  layout='responsive'
                  priority={index === 0}
                  objectFit={'cover'}
                />
              </div>
              <div className='text-md text-gray700'>{post.tag}</div>
              <div className='text-xl text-gray700'>{post.title}</div>
              <strong className='text-brand text-lg'>閱覽全文</strong>
            </a>
          </Link>
        ))}
        {media.map((m, index: number) => (
          <Link key={m.source} href={m.source}>
            <a rel='noopener' target='_blank' className='flex flex-col mb-4'>
              <div>
                <Image
                  src={m.imageUrl}
                  width={400}
                  height={300}
                  layout='responsive'
                  objectFit={'cover'}
                  priority={index === 0}
                />
              </div>
              <div className='text-md text-gray700'>
                {new Intl.DateTimeFormat('zh-TW').format(new Date(m.published_on ?? ''))}
              </div>
              <div className='flex mt-4'>
                {m.iconUrl && (
                  <div className='mr-2'>
                    <Image width={24} height={24} src={m.iconUrl} objectFit={'cover'} />
                  </div>
                )}
                <div className=' text-gray700'>{m.publisher}</div>
                {m.reporter && (
                  <div className='ml-4 pl-4 text-gray700' style={{ borderLeft: '1px solid' }}>
                    {m.reporter}
                  </div>
                )}
              </div>
              <div className='mt-4 text-xl text-gray700'>{m.title}</div>
              <strong className='mt-4 text-brand text-lg'>閱覽全文</strong>
            </a>
          </Link>
        ))}
      </SimpleGrid>
    </FullPage>
  );
}

export const getStaticProps = async ({ locale }: { locale: string }) => {
  const { data: media } = await FunwooAPI.mediaApi.findAll();
  const {
    data: { items: posts },
  } = await FunwooAPI.blog.getPublishedPosts({
    category: 'MEDIA',
  });
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      media: media.map(serializer),
      posts,
    },
    revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_INTERVAL),
  };
};
